import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Typography,
  Button
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    paddingBottom: theme.spacing(1),
    ...theme.typography.body1
  },
  dialogContent: {
    '& p': {
      color: theme.palette.grey[700]
    }
  },
  message1: {
    paddingBottom: theme.spacing(2)
  },
  dialogFoot: {
    display: 'flex',
    textAlign: 'right',
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(2)
  },
  button: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}));
type UserPreferencesInfo = {
  installId: string;
  name: string;
};
type ConfirmDialogProps = {
  open: boolean;
  setOpenConfirmDialog: (value: boolean) => void;
  onOptOut: () => void;
  userPreferencesInfo: UserPreferencesInfo;
};
export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  setOpenConfirmDialog,
  onOptOut,
  userPreferencesInfo
}: ConfirmDialogProps) => {
  const classes = useStyles();
  return (
    <Dialog
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth={'xs'}
      data-testid={'confirm-dialog'}
    >
      <DialogTitle className={classes.dialogTitle}>
        <FormattedMessage
          id="installedCollectors.confirmDialog.title"
          values={{ collectorName: userPreferencesInfo?.name }}
        />
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Typography className={classes.message1}>
          <FormattedMessage id="installedCollectors.confirmDialog.confirmationMessage" />
        </Typography>
        <Typography>
          <FormattedMessage id="installedCollectors.confirmDialog.confirmMessage" />
        </Typography>
      </DialogContent>
      <DialogActions className={classes.dialogFoot}>
        <Button
          color="secondary"
          className={classes.button}
          data-testid={'submit-dialog'}
          onClick={() => {
            setOpenConfirmDialog(false);
            if (onOptOut) onOptOut();
          }}
        >
          <FormattedMessage id="installedCollectors.confirmDialog.optout" />
        </Button>
        <Button
          color="primary"
          variant="contained"
          className={classes.button}
          data-testid={'cancel-dialog'}
          onClick={() => setOpenConfirmDialog(false)}
        >
          <FormattedMessage id="installedCollectors.confirmDialog.cancel" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
